import { useTheme } from '@mui/styles';

export const useCompensationCellStyles = () => {
  const theme = useTheme();

  return {
    dataCell: {
      verticalAlign: 'top !important',
    },
    text: {
      paddingBottom: theme.spacing(6),
      paddingTop: theme.spacing(1.25),
    },
  };
};
